import React from 'react'

import api from '../../apiClient/v1'
//Componentes
import { TablaHospedajes } from './TablaHospedajes.jsx'
import { ModalTrigger, ModalHospedaje } from './Modales.jsx'

import * as css from './MantenedorHospedajes.css'

let PropTypes = React.PropTypes

export class MantenedorHospedajes extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            hospedajes: []
        }
        this.getHospedajes=()=>{
            api.hospedajes().getHospedajes()
                .then(hospedajes=>{
                    this.setState({hospedajes})
                })
                .catch(err=>{console.log(err)})
        }
    }
    getChildContext(){
        return{
            guardaHospedaje:(datos)=>{
                let request = api.hospedajes().nuevoHospedaje(datos)
                request
                    .then(hospedaje=>{this.getHospedajes()})
                    .catch(err=>{})
                return request
            },
            getComunas:()=>{
                return api.otros.comunas()
            }
        }
    }
    componentWillMount(){
        this.getHospedajes()
    }
    render() {
        return (
            <div>
                <div className="col-md-12">
                    <h3>Mantenedor Hospedajes</h3>
                </div>
                <div className="col-md-1 pull-right form-group">
                    <ModalTrigger>
                        {(isVisible, showModal, hideModal)=>
                            <div>
                                <span className="btn btn-md btn-primary" onClick={showModal}>Nuevo</span>
                                {isVisible && <ModalHospedaje
                                    hideModal={hideModal}
                                    nuevo={1}
                                />}
                            </div>
                        }
                    </ModalTrigger>
                </div>
                <div className="col-md-12">
                    <TablaHospedajes
                        hospedajes={this.state.hospedajes}
                    />
                </div>
            </div>
        )
    }
}
MantenedorHospedajes.childContextTypes = {
    guardaHospedaje: PropTypes.func,
    getComunas: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/proveedores/hospedajes/MantenedorHospedajes.jsx